export default __webpack_public_path__ + "static/color-picker-accessible-role-dont-f0fdb32d68616a5e03f63e432e83f6cb84aa556adb1f33a9e6b843cdeed9a053.png";